import { Component, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { filter, forkJoin, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SidenavContentService } from './shared/sidenav/sidenav-content/sidenav-content.service';
import { PropertyManagementCompany } from '../../models/entities/property-management-company';
import { PropertyManagementCompanyService } from '../../services/property-management-company/property-management-company.service';
import { PropertyManagementCompanyDataService } from '../../services/property-management-company/property-manager-company-data.service';
import { HostListenerService } from '../../services/host-listener.service';
import { SvgIconService } from '../../services/svg-icon.service';
import { OrganizationDataService } from '../../services/organization/organization-data.service';
import { RouterButtonValue } from 'app/models/entities/router-button-value';

@UntilDestroy()
@Component({
    selector: 'app-v2-layout',
    styleUrls: ['./v2-layout.component.scss'],
    templateUrl: './v2-layout.component.html',
})
export class V2LayoutComponent implements OnInit
{
    @ViewChild('leftSidenav') leftSidenavRef!: MatSidenav;

    pmc$: Observable<PropertyManagementCompany>;
    routerLogoButton: RouterButtonValue;

    readonly appLogoSrc = '/assets/images/v2/payhoa/logo.svg';

    constructor(
            private _propertyManagementCompanyService: PropertyManagementCompanyService,
            private _propertyManagementCompanyData: PropertyManagementCompanyDataService,
            private _organizationDataService: OrganizationDataService,
            private _activatedRoute: ActivatedRoute,
            private _host: HostListenerService,
            private _svg: SvgIconService,
            private _sidenav: SidenavContentService,
    ) {
        // For now, use v2 svg icons for pmc dashboard
        this._svg.registerV2SvgIcons();
    }

    @ViewChild('rightSidenav', { static: true }) set rightSidenavRef(content: MatSidenav) {
        if (content) {
            this._sidenav._sidenav = content;
        }
    }

    get pmcId$() {
        return this._activatedRoute.paramMap.pipe(map((params) => +params?.get('pmcId')));
    }

    get showDemoModeBanner() {
        return this._organizationDataService.demoOrg$;
    }

    get mobileMode$() {
        return this._host.isMobileMode();
    }

    get tabletMode$() {
        return this._host.isTabletMode();
    }

    ngOnInit() {
        this.pmc$ = this._propertyManagementCompanyData.pmc$;
        this._propertyManagementCompanyData.clear();

        this.routerLogoButton = {
            label: 'Home',
            route: `/pmc`,
            ariaLabel: 'PayHOA app home',
        };

        this.pmcId$.pipe(
                filter((pmcId) => !!pmcId),
                switchMap((pmcId) => {
                    this._propertyManagementCompanyData.pmcId = pmcId;
                    return forkJoin([
                        this._propertyManagementCompanyService.getPropertyManagementCompany(pmcId).pipe(
                            map((pmc) => this._propertyManagementCompanyData.switch(pmc)),
                        ),
                        this._propertyManagementCompanyService.getPropertyManagementOrganizationList(),
                    ]);
                }),
                untilDestroyed(this),
        ).subscribe();
    }
}
